import { useIsMutating } from 'react-query';

export const useMutating = (mutationKeys: string[]): boolean => {
  const mutationCount = useIsMutating({
    predicate: (m) => mutationKeys.some((k) => k === m?.options?.mutationKey),
  });
  return Boolean(mutationCount);
};
